import { CashSavingsContributionsSumTable } from '../../../CashAccount';
import {
  AfterTaxSavingsContributionsSumTable,
  EducationSavingsContributionsSumTable,
  PreTaxSavingsContributionsSumTable,
} from '../../../Investment';
import { SavingsByCategoryProportionChart } from '../../../SrDetails';
import {
  AnimatedFabDivider,
  ClientSavingsRateScoreHealthRange,
  Divider,
  ElementDetailViewHeader,
  ElementDetailViewIndexPageContainer,
  ElementEducationVideoTile,
  Icon,
  ScorecardElementCalculationGroup,
} from '../../components';
import { useSavingsRateElementDetailViewIndexPage } from './hooks';
import { SavingsRateElementDetailViewIndexPageProps } from './types';
import VideoThumbnail from '../../../assets/Video-Savings Rate.png';
import { useWindowSize } from 'react-use';
import { SMTailwindMinPixelBreakpointWidth } from '../../../util';

export function SavingsRateElementDetailViewIndexPage({
  downloadReportButton,
  showScoreHealthRange,
  clickHandlers,
}: SavingsRateElementDetailViewIndexPageProps) {
  const { tPages, tScorecard, householdID, srDenominatorData, srDetails, srNumeratorData, firmID, clientID } =
    useSavingsRateElementDetailViewIndexPage();

  const isMobile = useWindowSize().width < SMTailwindMinPixelBreakpointWidth;

  return (
    <ElementDetailViewIndexPageContainer downloadReportButton={downloadReportButton}>
      <ElementDetailViewHeader
        title={tScorecard('savings-rate')}
        tooltipContainerClassName="md:!w-[264px]"
        tooltipDescription={tPages('savings-rate-element-detail-view-header-tooltip-description')}
      />
      <ScorecardElementCalculationGroup.DefaultComponent
        element="Sr"
        className="mb-12 "
        score={srDetails?.sr}
        numeratorData={srNumeratorData}
        denominatorData={srDenominatorData}
      />
      {showScoreHealthRange && <ClientSavingsRateScoreHealthRange firmClientID={clientID} firmID={firmID} />}
      <ElementEducationVideoTile
        thumbNail={<img src={VideoThumbnail} alt="Savings Rate thumbnail" />}
        body={
          isMobile
            ? tPages('savings-rate-element-detail-view-learn-more-body-mobile')
            : tPages('savings-rate-element-detail-view-learn-more-body')
        }
        label={tPages('savings-rate-element-detail-view-learn-more-label')}
        videoId={'1018763929'}
        className={'[&_figure]:max-h-[110px]'}
      />
      <div className="mt-10 mb-10">
        {clickHandlers?.addSavingsAssetOptions ? (
          <AnimatedFabDivider
            hoverWidth={256}
            onClick={clickHandlers?.addSavingsAssetOptions}
            label={tPages('savings-rate-element-detail-view-fab-label')}
            icon={<Icon icon="add" className="text-darkMode-gray-medium mix-blend-multiply" />}
          />
        ) : (
          <Divider className="-ml-12 w-[calc(100%_+_96px)]" />
        )}
      </div>
      <div className="peer/sumTables">
        <CashSavingsContributionsSumTable
          className={'max-w-[584px] mt-6'}
          hideOnEmpty
          householdID={householdID}
          onClickItem={clickHandlers?.editCashAccount}
        />
        <AfterTaxSavingsContributionsSumTable
          className={'max-w-[584px] mt-6'}
          hideOnEmpty
          householdID={householdID}
          onClickItem={clickHandlers?.editInvestment}
        />
        <PreTaxSavingsContributionsSumTable
          className={'max-w-[584px] mt-6'}
          hideOnEmpty
          householdID={householdID}
          onClickItem={clickHandlers?.editInvestment}
        />
        <EducationSavingsContributionsSumTable
          className={'max-w-[584px] mt-6'}
          hideOnEmpty
          householdID={householdID}
          onClickItem={clickHandlers?.editInvestment}
        />
      </div>
      <SavingsByCategoryProportionChart className="peer-empty/sumTables:mt-0 mt-8 " householdID={householdID} />
    </ElementDetailViewIndexPageContainer>
  );
}
